// Used in teacher-classes.component.ts

import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable()
export class TimeOfDayHelper {
    private currentTime = "";

    constructor() {}

    public getTimeOfDay(): string {
        this.currentTime = moment().format("HH:MM:SS");
        if (this.currentTime > "00:00:00" && this.currentTime < "12:00:00") {
            // 12:00:00 AM - 11:59:59 AM
            return "morning";
        } else if (
            this.currentTime >= "12:00:00" &&
            this.currentTime < "18:00:00"
        ) {
            // 12:00:00 PM - 05:59:59 PM
            return "afternoon";
        } else if (
            this.currentTime >= "18:00:00" &&
            this.currentTime < "23:59:59"
        ) {
            // 06:00:00 PM - 11:59:59 PM
            return "evening";
        }
        return "morning"; // default morning
    }

    public getTimeOfDayGreeting(): string {
        this.currentTime = moment().format("HH:MM:SS");
        if (this.currentTime > "00:00:00" && this.currentTime < "12:00:00") {
            // 12:00:00 AM - 11:59:59 AM
            return "Good Morning";
        } else if (
            this.currentTime >= "12:00:00" &&
            this.currentTime < "18:00:00"
        ) {
            // 12:00:00 PM - 05:59:59 PM
            return "Good Afternoon";
        } else if (
            this.currentTime >= "18:00:00" &&
            this.currentTime < "23:59:59"
        ) {
            // 06:00:00 PM - 11:59:59 PM
            return "Good Evening";
        }
        return "Good Morning"; // default morning
    }
}
